import { Link, useParams } from 'react-router-dom';
import SEO from '../../components/SEO';

const holidayEventsData = {
  1: {
    id: 1,
    title: "A Christmas Carol",
    venue: "Alley Theatre",
    dates: "November 16 – December 28, 2025",
    location: "Alley Theatre, Hubbard Theatre",
    address: "615 Texas Avenue, Houston, TX 77002",
    category: "Classic",
    description: "Experience Charles Dickens' timeless tale of redemption and holiday spirit in this spectacular theatrical production at Houston's renowned Alley Theatre.",
    pricing: "Tickets start at $36 (varies by date). Children under 6 are not admitted.",
    ageGroups: "Suitable for broad audiences. Note: Children under 6 not admitted. Uses strobe, flashing and revolving lights.",
    image: "https://public.readdy.ai/ai/img_res/0b2df332d6317bb57a0011f671ec5090.jpg",
    overview: "The Alley Theatre's production of A Christmas Carol has become a beloved Houston holiday tradition. This faithful adaptation of Charles Dickens' classic story follows the transformation of Ebenezer Scrooge from a miserly curmudgeon to a generous soul, guided by the ghosts of Christmas Past, Present, and Future. The production features elaborate Victorian-era costumes, stunning set designs, and theatrical magic that brings 19th-century London to life on stage.",
    whatToExpect: [
      {
        title: "Victorian Spectacle",
        description: "Immerse yourself in the sights and sounds of Victorian London with authentic period costumes, detailed set pieces, and atmospheric lighting that transports you to Dickens' world."
      },
      {
        title: "Theatrical Magic",
        description: "Experience the wonder of live theatre with flying ghosts, transformation scenes, and special effects that bring the supernatural elements of the story to life."
      },
      {
        title: "Timeless Message",
        description: "Rediscover the power of redemption, generosity, and the true meaning of Christmas through this heartwarming tale that resonates across generations."
      },
      {
        title: "Professional Production",
        description: "Enjoy world-class performances from the Alley Theatre's talented ensemble cast, bringing depth and emotion to these beloved characters."
      }
    ],
    practicalInfo: [
      {
        icon: "ri-time-line",
        title: "Show Duration",
        detail: "Approximately 2 hours including intermission"
      },
      {
        icon: "ri-ticket-line",
        title: "Ticket Pricing",
        detail: "Starting at $36, varies by date and seat location"
      },
      {
        icon: "ri-group-line",
        title: "Age Requirement",
        detail: "Children under 6 not admitted"
      },
      {
        icon: "ri-parking-line",
        title: "Parking",
        detail: "Downtown parking garages nearby, arrive early during holidays"
      }
    ],
    helpfulTips: [
      "Book early for best dates and seats - this holiday show tends to fill quickly, especially weekend performances",
      "Consider weekday or preview performances for lower pricing and smaller crowds",
      "Be aware of lighting effects (strobe/flashing) if you have children or individuals sensitive to that",
      "Downtown theatre parking may fill up during holiday season - arrive 30-45 minutes early",
      "Dress code is smart casual - many attendees dress up for the holiday atmosphere",
      "The Hubbard Theatre is an intimate space - even upper level seats offer good views"
    ],
    historicalContext: "The Alley Theatre, founded in 1947, is one of the oldest resident theatres in the United States. Their production of A Christmas Carol has become a Houston holiday tradition, introducing new generations to Dickens' classic tale while maintaining the theatrical excellence that has made the Alley Theatre a cultural cornerstone of Houston's Theatre District."
  },
  2: {
    id: 2,
    title: "Irving Berlin's White Christmas",
    venue: "Theatre Under The Stars",
    dates: "December 9 – 24, 2025",
    location: "Theatre Under The Stars at the Hobby Center for the Performing Arts",
    address: "800 Bagby Street, Houston, TX 77002",
    category: "Musical",
    description: "Celebrate the season with this beloved musical featuring Irving Berlin's timeless songs, including the classic title number, in a spectacular holiday production.",
    pricing: "Ticket pricing varies by performance and seating. Check Theatre Under The Stars website for current rates.",
    ageGroups: "Family-friendly holiday musical suitable for children and adults of all ages.",
    image: "https://readdy.ai/api/search-image?query=White%20Christmas%20musical%20theatre%20production%20with%20performers%20in%201950s%20costumes%2C%20snow%20falling%20on%20stage%2C%20festive%20holiday%20atmosphere%2C%20Broadway-style%20performance%2C%20vintage%20holiday%20glamour&width=800&height=500&seq=white-christmas-detail&orientation=landscape",
    overview: "Irving Berlin's White Christmas brings the magic of the beloved 1954 film to the stage in this heartwarming musical spectacular. Follow the story of two World War II veterans who team up to save their former commander's struggling Vermont inn with a spectacular holiday show. Featuring Irving Berlin's unforgettable songs including 'Blue Skies,' 'I Love a Piano,' and the iconic 'White Christmas,' this production captures the nostalgia, romance, and joy of the holiday season.",
    whatToExpect: [
      {
        title: "Irving Berlin's Greatest Hits",
        description: "Enjoy over 20 classic songs from one of America's greatest composers, including 'White Christmas,' 'Blue Skies,' 'I Love a Piano,' and 'How Deep Is the Ocean.'"
      },
      {
        title: "Spectacular Snow Finale",
        description: "Experience the magic of falling snow during the show's climactic finale - a theatrical moment that delights audiences of all ages."
      },
      {
        title: "1950s Glamour",
        description: "Marvel at the gorgeous period costumes, elaborate choreography, and vintage holiday aesthetic that captures the golden age of American entertainment."
      },
      {
        title: "Heartwarming Story",
        description: "Follow a tale of friendship, romance, and holiday spirit that celebrates the bonds formed through shared experiences and the power of community."
      }
    ],
    practicalInfo: [
      {
        icon: "ri-time-line",
        title: "Show Duration",
        detail: "Approximately 2 hours 30 minutes including intermission"
      },
      {
        icon: "ri-ticket-line",
        title: "Ticket Pricing",
        detail: "Varies by performance and seating section"
      },
      {
        icon: "ri-group-line",
        title: "Age Suitability",
        detail: "Family-friendly, suitable for all ages"
      },
      {
        icon: "ri-parking-line",
        title: "Parking",
        detail: "Hobby Center parking garage and nearby lots available"
      }
    ],
    helpfulTips: [
      "The production features a snow finale - dress accordingly as some snow effect may reach audience areas",
      "Holiday performances mean heavier traffic and parking near the Hobby Center - plan transportation ahead",
      "Arrive 30-45 minutes early to get settled before the show starts, especially during busy holiday weekends",
      "Consider matinee performances for a more relaxed experience with families",
      "The Hobby Center offers excellent acoustics throughout - most seats provide great sound quality",
      "Make it a full evening by dining at one of the many restaurants in the Theatre District before the show"
    ],
    historicalContext: "Theatre Under The Stars (TUTS) has been bringing Broadway-quality musicals to Houston since 1968. Originally performing outdoors in Hermann Park, TUTS now calls the Hobby Center home, continuing its mission to make musical theatre accessible to all Houstonians. White Christmas represents the kind of classic American musical that TUTS excels at producing - combining nostalgia, spectacular production values, and timeless entertainment."
  },
  3: {
    id: 3,
    title: "Elf in Concert",
    venue: "Houston Symphony",
    dates: "December 19 – 21, 2025",
    location: "Houston Symphony at Jones Hall",
    address: "615 Louisiana Street, Houston, TX 77002",
    category: "Concert",
    description: "Watch the beloved holiday film Elf on the big screen while the Houston Symphony performs the complete musical score live, creating an unforgettable holiday experience.",
    pricing: "Ticket pricing varies by performance and seating section. Check Houston Symphony website for details.",
    ageGroups: "Very family-friendly - the film Elf is popular with children and families of all ages.",
    image: "https://readdy.ai/api/search-image?query=Houston%20Symphony%20performing%20at%20Jones%20Hall%20with%20orchestra%20musicians%2C%20movie%20screen%20showing%20Elf%20film%2C%20families%20in%20audience%2C%20festive%20holiday%20concert%20atmosphere%2C%20live%20music%20performance&width=800&height=500&seq=elf-concert-detail&orientation=landscape",
    overview: "Experience the magic of Elf like never before as the Houston Symphony performs John Debney's delightful musical score live while the beloved film plays on the big screen above. This unique concert experience combines the joy of watching Will Ferrell's hilarious performance as Buddy the Elf with the grandeur of a full symphony orchestra, creating a multi-sensory holiday celebration that brings new depth and appreciation to this modern Christmas classic.",
    whatToExpect: [
      {
        title: "Live Orchestra Performance",
        description: "The Houston Symphony performs John Debney's complete musical score live, synchronized perfectly with the film, adding a new dimension to the movie-watching experience."
      },
      {
        title: "Big Screen Viewing",
        description: "Watch Elf on a massive screen in the beautiful Jones Hall while the orchestra brings the music to life below, creating an immersive theatrical experience."
      },
      {
        title: "Family-Friendly Fun",
        description: "Enjoy Buddy's fish-out-of-water adventures in New York City, from spaghetti with maple syrup to the iconic snowball fight in Central Park, all enhanced by live music."
      },
      {
        title: "Holiday Spirit",
        description: "Rediscover the film's heartwarming message about believing in Christmas magic, family, and spreading joy - amplified by the emotional power of live orchestral music."
      }
    ],
    practicalInfo: [
      {
        icon: "ri-time-line",
        title: "Event Duration",
        detail: "Approximately 2 hours (film runtime plus pre-show)"
      },
      {
        icon: "ri-ticket-line",
        title: "Ticket Pricing",
        detail: "Varies by performance date and seating section"
      },
      {
        icon: "ri-group-line",
        title: "Age Suitability",
        detail: "Perfect for families with children of all ages"
      },
      {
        icon: "ri-parking-line",
        title: "Parking",
        detail: "Jones Hall parking garage and nearby Theatre District lots"
      }
    ],
    helpfulTips: [
      "Arrive 30 minutes early - exciting holiday concert events attract large family audiences and seating takes time",
      "If bringing children, consider seat location for comfort and visibility - orchestra level offers best view of both screen and orchestra",
      "The film runs approximately 97 minutes - plan accordingly for younger children's attention spans",
      "Parking around Jones Hall gets busy during holiday season - consider ride-share or arrive early",
      "Jones Hall has excellent acoustics throughout, but center orchestra and first tier offer the best combined view of screen and musicians",
      "Make it a special outing - many families dress in holiday attire or even Elf-themed costumes"
    ],
    historicalContext: "Jones Hall, opened in 1966, serves as the home of the Houston Symphony and stands as one of the finest concert halls in the United States. The Symphony's film concert series represents a modern evolution of the orchestra's mission to make classical music accessible and relevant to new audiences. By pairing beloved films with live orchestral performance, these concerts introduce families to the power of symphonic music while celebrating popular culture."
  },
  4: {
    id: 4,
    title: "The Nutcracker",
    venue: "Houston Ballet",
    dates: "November 28 – December 28, 2025",
    location: "Houston Ballet at Wortham Theater Center",
    address: "501 Texas Avenue, Houston, TX 77002",
    category: "Ballet",
    description: "Experience the ultimate holiday tradition with Houston Ballet's spectacular production of The Nutcracker, featuring Tchaikovsky's beloved score and breathtaking choreography.",
    pricing: "Tickets start around $60+. Pricing varies by performance date and seating section.",
    ageGroups: "Ideal for families, older children, and adults. May be less suited for very young toddlers unless accustomed to longer performances.",
    image: "https://readdy.ai/api/search-image?query=Houston%20Ballet%20performing%20The%20Nutcracker%20with%20ballerinas%20in%20tutus%2C%20Sugar%20Plum%20Fairy%2C%20elaborate%20stage%20sets%2C%20Christmas%20tree%20transformation%20scene%2C%20classical%20ballet%20performance%2C%20elegant%20theatrical%20production&width=800&height=500&seq=nutcracker-detail&orientation=landscape",
    overview: "Houston Ballet's production of The Nutcracker is the ultimate holiday tradition, enchanting audiences for over 30 years with its magical blend of Tchaikovsky's immortal score, stunning choreography, and spectacular production design. Follow young Clara's Christmas Eve journey through a world of dancing snowflakes, battling toy soldiers, and the enchanted Kingdom of Sweets. This beloved ballet combines technical excellence with theatrical magic, creating an unforgettable experience that has introduced generations of Houstonians to the beauty of classical dance.",
    whatToExpect: [
      {
        title: "World-Class Ballet",
        description: "Experience the artistry of Houston Ballet's professional dancers performing Stanton Welch's acclaimed choreography, from the delicate Snow Scene to the virtuosic Grand Pas de Deux."
      },
      {
        title: "Tchaikovsky's Masterpiece",
        description: "Hear the Houston Ballet Orchestra perform Tchaikovsky's beloved score live, including iconic pieces like 'Dance of the Sugar Plum Fairy' and 'Waltz of the Flowers.'"
      },
      {
        title: "Spectacular Production",
        description: "Marvel at the elaborate sets and costumes, including the magical growing Christmas tree, the battle with the Mouse King, and the glittering Kingdom of Sweets."
      },
      {
        title: "Holiday Magic",
        description: "Witness the transformation of Clara's Christmas Eve into a fantastical adventure, capturing the wonder and imagination of the holiday season through dance."
      }
    ],
    practicalInfo: [
      {
        icon: "ri-time-line",
        title: "Performance Length",
        detail: "Approximately 2 hours including intermission"
      },
      {
        icon: "ri-ticket-line",
        title: "Ticket Pricing",
        detail: "Starting around $60+, varies by date and seating"
      },
      {
        icon: "ri-group-line",
        title: "Age Recommendation",
        detail: "Best for ages 5+, though all ages welcome"
      },
      {
        icon: "ri-parking-line",
        title: "Parking",
        detail: "Wortham Center parking and nearby Theatre District garages"
      }
    ],
    helpfulTips: [
      "For best experience, choose orchestra or first mezzanine seats for optimal view of the choreography and stage details",
      "The production runs approximately 2 hours with intermission - plan accordingly for younger children",
      "Consider matinee performances for families with younger children - they tend to be more relaxed",
      "Book early for popular dates like Christmas week and weekend performances",
      "Arrive 30 minutes early to allow time for parking, finding seats, and soaking in the pre-show atmosphere",
      "Many families make this an annual tradition - consider dressing up for a special holiday outing",
      "The Wortham Center offers excellent sightlines throughout, but avoid extreme side seats for best view"
    ],
    historicalContext: "Houston Ballet, founded in 1969, has grown into one of the nation's premier ballet companies. Their production of The Nutcracker, staged annually since the company's early years, has become Houston's quintessential holiday tradition. Artistic Director Stanton Welch's acclaimed version honors the classical ballet tradition while adding fresh theatrical elements that keep the production vibrant and relevant for contemporary audiences. The production has introduced countless Houston children to the art of ballet, many of whom have gone on to dance professionally."
  },
  5: {
    id: 5,
    title: "Houston Ballet Nutcracker Market®",
    venue: "NRG Park",
    dates: "November 13 – 16, 2025",
    location: "NRG Park",
    address: "NRG Parkway, Houston, TX 77054",
    category: "Shopping",
    description: "Shop for unique gifts and holiday treasures at Houston's premier holiday market, featuring hundreds of merchants while supporting Houston Ballet's education programs.",
    pricing: "General Admission: $20 for one-day entry. Early Bird: $60 for all four days. Children 2 and under free.",
    ageGroups: "Great for all ages. Shopping and festive atmosphere suitable for families, though younger children may tire during extended visits.",
    image: "https://readdy.ai/api/search-image?query=Houston%20Nutcracker%20Market%20at%20NRG%20Park%20with%20holiday%20shopping%20booths%2C%20festive%20decorations%2C%20shoppers%20browsing%20unique%20gifts%2C%20holiday%20market%20atmosphere%2C%20vendor%20displays%20with%20crafts%20and%20merchandise&width=800&height=500&seq=nutcracker-market-detail&orientation=landscape",
    overview: "The Houston Ballet Nutcracker Market® is Houston's most anticipated holiday shopping event, transforming NRG Park into a winter wonderland filled with unique gifts, gourmet foods, home décor, jewelry, fashion, and more. Since 1981, this beloved market has featured hundreds of carefully curated merchants from across the country, offering one-of-a-kind items you won't find anywhere else. Beyond the shopping, the market serves a philanthropic mission - all proceeds benefit Houston Ballet's education and community programs, making every purchase support the arts in Houston.",
    whatToExpect: [
      {
        title: "Hundreds of Unique Merchants",
        description: "Browse offerings from over 300 merchants featuring jewelry, fashion, home décor, gourmet foods, children's items, art, and specialty gifts you won't find in typical stores."
      },
      {
        title: "Holiday Shopping Paradise",
        description: "Find perfect gifts for everyone on your list in one location, from handcrafted artisan pieces to luxury items, all in a festive holiday atmosphere."
      },
      {
        title: "Gourmet Food &amp; Treats",
        description: "Sample and purchase gourmet foods, holiday treats, specialty ingredients, and culinary gifts from vendors across the country."
      },
      {
        title: "Supporting the Arts",
        description: "Every purchase supports Houston Ballet's scholarship programs and community education initiatives, making your holiday shopping meaningful and impactful."
      }
    ],
    practicalInfo: [
      {
        icon: "ri-time-line",
        title: "Market Hours",
        detail: "Four days: November 13-16, 2025 (specific hours vary by day)"
      },
      {
        icon: "ri-ticket-line",
        title: "Admission Pricing",
        detail: "$20 one-day, $60 Early Bird (all 4 days), Kids 2 &amp; under free"
      },
      {
        icon: "ri-group-line",
        title: "Age Suitability",
        detail: "All ages welcome, best for those who enjoy shopping"
      },
      {
        icon: "ri-parking-line",
        title: "Parking",
        detail: "NRG Park parking lots (may be busy, arrive early)"
      }
    ],
    helpfulTips: [
      "Arrive early, especially on opening days, for best vendor selection and to avoid crowds",
      "Wear comfortable shoes - the market is extensive and you'll be walking for hours",
      "Bring a list and set a budget - with so many tempting items, it's easy to overspend",
      "Consider the Early Bird pass ($60) if you're a serious shopper - it pays for itself and allows multiple visits",
      "Parking and traffic into NRG Park can be heavy - allow extra time, especially on weekends",
      "Bring reusable shopping bags or a rolling cart for your purchases",
      "Many vendors accept credit cards, but bring some cash for smaller merchants",
      "Take breaks at the food vendors - shopping is exhausting and you'll need energy",
      "Follow Houston Ballet on social media for vendor previews and special promotions"
    ],
    historicalContext: "The Nutcracker Market began in 1981 as a small fundraiser for Houston Ballet and has grown into one of the largest and most successful charity markets in the nation. Over four decades, the market has raised millions of dollars to support Houston Ballet's scholarship programs, academy operations, and community education initiatives. The market's success demonstrates Houston's commitment to supporting the arts while providing a unique shopping experience that has become a cherished holiday tradition for generations of Houston families."
  },
  6: {
    id: 6,
    title: "Home for the Holidays in Old Town Spring",
    venue: "Old Town Spring",
    dates: "November 22 – December 21, 2025 (Weekends Only)",
    location: "Old Town Spring",
    address: "123 Main Street, Spring, TX 77373",
    category: "Charming",
    description: "Experience the magic of a small-town holiday celebration in Old Town Spring with festive lights, tree lighting ceremony, photos with Santa, shopping, and family entertainment.",
    pricing: "Free admission. Individual shop and activity pricing varies.",
    ageGroups: "Family-friendly - perfect for all ages with shopping, lights, photos with Santa, and entertainment.",
    image: "https://readdy.ai/api/search-image?query=Old%20Town%20Spring%20Texas%20Christmas%20holiday%20decorations%20with%20festive%20lights%2C%20charming%20historic%20buildings%20decorated%20for%20holidays%2C%20families%20shopping%20at%20boutiques%2C%20vintage%20small%20town%20atmosphere%2C%20warm%20evening%20glow%2C%20Christmas%20tree%20lighting&width=800&height=500&seq=old-town-spring-detail&orientation=landscape",
    overview: "Home for the Holidays transforms Old Town Spring into a charming winter wonderland every weekend from late November through December. This beloved North Houston tradition captures the essence of small-town holiday celebrations with twinkling lights adorning historic buildings, festive decorations throughout the district, and a warm community atmosphere. The season kicks off with a spectacular tree lighting ceremony on November 22, followed by weekends filled with photos with Santa, live entertainment, unique shopping at local boutiques, and family-friendly activities that create lasting holiday memories.",
    whatToExpect: [
      {
        title: "Tree Lighting Kickoff",
        description: "The season begins with a magical tree lighting ceremony on November 22. Watch as Old Town Spring's Christmas tree illuminates for the first time, accompanied by caroling, hot cocoa, and festive cheer."
      },
      {
        title: "Photos with Santa",
        description: "Children can meet Santa Claus and share their Christmas wishes while parents capture precious holiday photos in a charming small-town setting."
      },
      {
        title: "Unique Shopping Experience",
        description: "Browse over 150 specialty shops, boutiques, and galleries offering handcrafted gifts, antiques, home décor, jewelry, and one-of-a-kind treasures you won't find anywhere else."
      },
      {
        title: "Festive Lights &amp; Decorations",
        description: "Stroll through streets adorned with twinkling lights, holiday decorations, and seasonal displays that create a picture-perfect holiday atmosphere throughout the historic district."
      }
    ],
    practicalInfo: [
      {
        icon: "ri-time-line",
        title: "Event Schedule",
        detail: "Weekends only: Nov 22 - Dec 21, 2025"
      },
      {
        icon: "ri-ticket-line",
        title: "Admission",
        detail: "Free to visit; individual shop and activity pricing varies"
      },
      {
        icon: "ri-group-line",
        title: "Age Suitability",
        detail: "Family-friendly for all ages"
      },
      {
        icon: "ri-parking-line",
        title: "Parking",
        detail: "Free parking lots available; fills quickly on busy weekends"
      }
    ],
    helpfulTips: [
      "Arrive early for the tree lighting ceremony on November 22 to capture the best photos and secure good viewing spots",
      "Old Town Spring is about 30-40 minutes north of downtown Houston - plan travel time accordingly, especially from the Conroe area",
      "Parking fills quickly on busy weekends - arrive early or consider carpooling with family and friends",
      "Many shops and eateries are available - consider making it a full day with brunch or dinner before or after exploring",
      "Wear comfortable walking shoes as you'll be strolling through the historic district for hours",
      "Bring your camera - the festive lights and decorations create perfect holiday photo opportunities",
      "Check individual shop hours as some may have extended holiday hours on event weekends",
      "The area is outdoors - dress in layers as Texas weather can be unpredictable in late fall and winter"
    ],
    historicalContext: "Old Town Spring has been a beloved North Houston destination since the 1970s when local entrepreneurs began restoring historic buildings and transforming the area into a charming shopping and entertainment district. The Home for the Holidays celebration has become an annual tradition that showcases the community's commitment to preserving small-town charm while creating magical holiday experiences for families. The event reflects the spirit of Old Town Spring - a place where history, community, and celebration come together to create something special."
  },
  7: {
    id: 7,
    title: "Zoo Lights at Houston Zoo",
    venue: "Houston Zoo",
    dates: "November 21, 2025 – January 4, 2026",
    location: "Houston Zoo",
    address: "6200 Hermann Park Drive, Houston, TX 77030",
    category: "Popular",
    description: "Experience over 2 million twinkling lights transforming Houston Zoo into a magical winter wonderland with illuminated animal sculptures, immersive displays, and festive family fun.",
    pricing: "Timed entry tickets required. Pricing varies by date. Check Houston Zoo website for current rates.",
    ageGroups: "Excellent for families and children - walking lights displays, immersive experiences, and holiday atmosphere.",
    image: "https://readdy.ai/api/search-image?query=Houston%20Zoo%20Lights%20spectacular%20Christmas%20display%20with%20millions%20of%20colorful%20illuminated%20lights%2C%20glowing%20animal%20sculptures%2C%20families%20walking%20through%20magical%20pathways%2C%20festive%20holiday%20atmosphere%2C%20twinkling%20trees%2C%20winter%20evening%20celebration&width=800&height=500&seq=zoo-lights-detail&orientation=landscape",
    overview: "Zoo Lights is Houston's most spectacular holiday light display, transforming the Houston Zoo into an enchanted wonderland of over 2 million twinkling lights. This beloved annual tradition features stunning illuminated animal sculptures, immersive light tunnels, festive music, and magical displays that delight visitors of all ages. As you walk through the zoo's pathways, you'll encounter glowing giraffes, sparkling elephants, and countless other light creations that bring the animal kingdom to life in a whole new way. The event combines the wonder of wildlife with the magic of the holidays, creating an unforgettable experience that has become a must-see Houston tradition.",
    whatToExpect: [
      {
        title: "2 Million+ Lights",
        description: "Marvel at over 2 million individual lights creating breathtaking displays throughout the zoo, from towering light sculptures to twinkling pathways that guide you through the magical experience."
      },
      {
        title: "Illuminated Animal Sculptures",
        description: "Encounter larger-than-life light sculptures of your favorite animals - giraffes, elephants, lions, and more - all glowing in vibrant colors that bring them to life in spectacular fashion."
      },
      {
        title: "Immersive Light Displays",
        description: "Walk through enchanting light tunnels, under glowing archways, and past interactive displays that create photo-perfect moments and immersive holiday experiences."
      },
      {
        title: "Family-Friendly Activities",
        description: "Enjoy festive music, holiday treats, photo opportunities, and special activities designed to create lasting memories for families and children of all ages."
      }
    ],
    practicalInfo: [
      {
        icon: "ri-time-line",
        title: "Event Duration",
        detail: "Nov 21, 2025 - Jan 4, 2026 (evening hours)"
      },
      {
        icon: "ri-ticket-line",
        title: "Tickets",
        detail: "Timed entry required; pricing varies by date"
      },
      {
        icon: "ri-group-line",
        title: "Age Suitability",
        detail: "Excellent for families with children of all ages"
      },
      {
        icon: "ri-parking-line",
        title: "Parking",
        detail: "Zoo parking lots; arrive early to avoid congestion"
      }
    ],
    helpfulTips: [
      "Dress in layers for evening visits - while Houston winters are mild, evenings can be cool, especially in December and January",
      "Purchase timed entry tickets in advance online to guarantee admission and avoid sold-out dates",
      "Arrive early to secure parking - the zoo parking lots fill quickly on popular nights, especially weekends and holidays",
      "Consider visiting earlier in the season (late November/early December) before the New Year's rush for smaller crowds",
      "Bring a camera or smartphone - the light displays create incredible photo opportunities throughout the zoo",
      "Wear comfortable walking shoes as you'll be strolling through the zoo for 1-2 hours",
      "Check the weather forecast and bring umbrellas if rain is expected - the event continues in light rain",
      "Plan for 1.5 to 2 hours to fully experience all the light displays and take photos",
      "Concessions are available - consider grabbing hot cocoa or holiday treats to enjoy while you explore"
    ],
    historicalContext: "Zoo Lights began as a small holiday event and has grown into one of Houston's most beloved seasonal traditions, attracting hundreds of thousands of visitors each year. The Houston Zoo, founded in 1922, has been a cornerstone of the city's cultural landscape for over a century. Zoo Lights represents the zoo's commitment to creating magical experiences while supporting its conservation and education mission - proceeds from the event help fund the zoo's wildlife conservation programs and animal care initiatives, making every visit both entertaining and meaningful."
  },
  8: {
    id: 8,
    title: "Deck the Hall: Mayor's Holiday Spectacular",
    venue: "Downtown Houston",
    dates: "December 6, 2025",
    location: "Downtown Houston",
    address: "Downtown Houston, TX 77002",
    category: "Tradition",
    description: "Join Houston's official holiday celebration with the Mayor's tree lighting ceremony, outdoor concert, festive entertainment, and community celebration in the heart of downtown.",
    pricing: "Free public event",
    ageGroups: "Good for families and general public - outdoor concert plus tree lighting ceremony.",
    image: "https://readdy.ai/api/search-image?query=Houston%20downtown%20Christmas%20tree%20lighting%20ceremony%20with%20massive%20decorated%20tree%2C%20large%20crowds%20gathered%20for%20celebration%2C%20mayor%20speaking%20at%20podium%2C%20festive%20downtown%20atmosphere%2C%20holiday%20lights%20illuminating%20city%20buildings%2C%20community%20celebration&width=800&height=500&seq=mayors-spectacular-detail&orientation=landscape",
    overview: "Deck the Hall: Mayor's Holiday Spectacular is Houston's official kickoff to the holiday season, bringing the community together for an unforgettable evening of celebration in downtown Houston. This beloved annual tradition features the ceremonial lighting of Houston's grand Christmas tree, live musical performances, festive entertainment, and the warm spirit of community that defines the city. As the Mayor flips the switch and the tree illuminates against the downtown skyline, thousands of Houstonians join together in celebration, marking the beginning of the most wonderful time of the year. The event captures the diversity, energy, and community spirit that makes Houston special.",
    whatToExpect: [
      {
        title: "Grand Tree Lighting",
        description: "Witness the magical moment when Houston's official Christmas tree lights up for the first time, creating a spectacular display against the downtown skyline as the Mayor leads the countdown."
      },
      {
        title: "Live Outdoor Concert",
        description: "Enjoy performances from local musicians, choirs, and entertainers on the outdoor stage, featuring holiday classics, contemporary favorites, and festive music that gets everyone in the holiday spirit."
      },
      {
        title: "Community Celebration",
        description: "Join thousands of fellow Houstonians in a free public celebration that brings together families, friends, and neighbors from across the city to mark the start of the holiday season."
      },
      {
        title: "Festive Entertainment",
        description: "Experience additional holiday activities, photo opportunities, and entertainment throughout the downtown area, creating a full evening of family-friendly fun."
      }
    ],
    practicalInfo: [
      {
        icon: "ri-time-line",
        title: "Event Date",
        detail: "December 6, 2025 (evening)"
      },
      {
        icon: "ri-ticket-line",
        title: "Admission",
        detail: "Free public event"
      },
      {
        icon: "ri-group-line",
        title: "Age Suitability",
        detail: "Family-friendly for all ages"
      },
      {
        icon: "ri-parking-line",
        title: "Parking",
        detail: "Downtown garages; consider Metro or ride-share"
      }
    ],
    helpfulTips: [
      "Arrive early for the best viewing spots, especially if attending with children - the event draws large crowds",
      "This is an outdoor event - bring jackets and dress in layers as December evenings in Houston can be cool",
      "Expect big crowds - establish a meeting point with your group in case anyone gets separated",
      "Consider using Metro Rail or ride-share services instead of driving to avoid parking hassles and traffic",
      "Downtown parking garages fill quickly - if driving, arrive well before the event starts",
      "Bring blankets or portable chairs if you want to sit during the concert portions",
      "The event is free and open to the public - no tickets or reservations required",
      "Check the official event website or social media for exact timing and any special announcements",
      "Nearby restaurants and cafes offer pre-event dining options - consider making it a full evening downtown"
    ],
    historicalContext: "The Mayor's Holiday Spectacular has been a Houston tradition for decades, serving as the city's official welcome to the holiday season. The event reflects Houston's character as a diverse, welcoming city that celebrates together as one community. Downtown Houston, once primarily a business district, has transformed into a vibrant cultural and entertainment destination, and events like the Mayor's Holiday Spectacular showcase the area's evolution into a gathering place for all Houstonians. The tree lighting ceremony symbolizes the city's unity and shared celebration of the season."
  },
  9: {
    id: 9,
    title: "Breakfast with Santa at Downtown Aquarium",
    venue: "Downtown Aquarium",
    dates: "December 6, 13, 14, 20–24, 2025",
    location: "Downtown Aquarium",
    address: "410 Bagby Street, Houston, TX 77002",
    category: "Special",
    description: "Create magical holiday memories with a festive breakfast buffet, personal time with Santa Claus, holiday photos, and underwater views at Downtown Aquarium.",
    pricing: "Reservations required. Pricing includes breakfast buffet and Santa visit. Check Downtown Aquarium website for rates.",
    ageGroups: "Families with children are the primary target - kids will love meeting Santa and seeing the aquarium.",
    image: "https://readdy.ai/api/search-image?query=Downtown%20Aquarium%20Houston%20Christmas%20breakfast%20with%20Santa%20Claus%20sitting%20with%20children%2C%20families%20dining%20at%20festive%20holiday%20buffet%2C%20colorful%20fish%20tanks%20in%20background%2C%20magical%20underwater%20atmosphere%2C%20holiday%20decorations%2C%20children%20excited%20to%20meet%20Santa&width=800&height=500&seq=breakfast-santa-detail&orientation=landscape",
    overview: "Breakfast with Santa at Downtown Aquarium combines the magic of meeting Santa Claus with the wonder of underwater exploration, creating a unique holiday experience that children will treasure forever. This special event offers families the opportunity to enjoy a delicious breakfast buffet while surrounded by stunning aquarium exhibits, followed by personal time with Santa for photos and wish-sharing. The combination of festive dining, marine life encounters, and Santa's visit creates a multi-sensory holiday experience that stands out from traditional Santa photo opportunities. It's a perfect way to create lasting memories while enjoying the Downtown Aquarium's spectacular underwater world.",
    whatToExpect: [
      {
        title: "Festive Breakfast Buffet",
        description: "Enjoy a delicious holiday breakfast buffet featuring kid-friendly favorites, seasonal specialties, and a variety of options for the whole family in the aquarium's unique dining atmosphere."
      },
      {
        title: "Personal Time with Santa",
        description: "Each child gets quality time with Santa Claus to share their Christmas wishes, receive a special gift, and create memories that will last a lifetime."
      },
      {
        title: "Professional Holiday Photos",
        description: "Capture the magic with professional photos of your children with Santa, plus countless opportunities for family photos throughout the beautifully decorated aquarium."
      },
      {
        title: "Underwater Dining Experience",
        description: "Dine surrounded by stunning aquarium exhibits featuring colorful fish, sharks, and marine life swimming overhead and around you, creating a truly unique breakfast setting."
      }
    ],
    practicalInfo: [
      {
        icon: "ri-time-line",
        title: "Event Dates",
        detail: "Dec 6, 13, 14, 20-24, 2025 (specific times vary)"
      },
      {
        icon: "ri-ticket-line",
        title: "Reservations",
        detail: "Required - book early as slots fill quickly"
      },
      {
        icon: "ri-group-line",
        title: "Age Suitability",
        detail: "Perfect for families with young children"
      },
      {
        icon: "ri-parking-line",
        title: "Parking",
        detail: "Aquarium parking lot or downtown garages"
      }
    ],
    helpfulTips: [
      "Reserve early - specific date slots fill quickly, especially for dates closer to Christmas (Dec 20-24)",
      "Arrive early to be seated promptly and maximize your buffet and Santa time",
      "Parking at the Downtown Aquarium area may require planning - the aquarium has its own lot, or use nearby downtown parking garages",
      "Bring your camera or smartphone for photos, though professional photos with Santa are typically available for purchase",
      "Consider the breakfast timing when planning your day - you can often explore the aquarium exhibits after breakfast",
      "Dress children in festive outfits for adorable holiday photos with Santa",
      "The buffet is kid-friendly, but check the menu if your children have specific dietary needs or restrictions",
      "Plan for 1.5 to 2 hours for the full breakfast and Santa experience",
      "This event is popular - book as soon as reservations open to secure your preferred date"
    ],
    historicalContext: "Downtown Aquarium, located in the heart of Houston, has been a family entertainment destination since its opening in 2003. The facility combines dining, entertainment, and marine education in a unique downtown setting. Breakfast with Santa has become one of the aquarium's most popular seasonal events, offering families a distinctive alternative to traditional mall Santa visits. The event reflects the aquarium's mission to create memorable experiences while fostering appreciation for marine life and ocean conservation."
  },
  10: {
    id: 10,
    title: "Celebrating Kwanzaa at Children's Museum Houston",
    venue: "Children's Museum Houston",
    dates: "December 26, 2025",
    location: "Children's Museum Houston",
    address: "1500 Binz Street, Houston, TX 77004",
    category: "Cultural",
    description: "Children's Museum Houston hosts an educational and interactive Kwanzaa celebration with art workshops, traditional African drumming circle, and hands-on cultural activities for kids.",
    pricing: "Museum admission required. Check Children's Museum Houston website for current rates and special event details.",
    ageGroups: "Kids are the focus - workshop and interactive drumming circle designed for children and families.",
    image: "https://readdy.ai/api/search-image?query=Children%20Museum%20Houston%20Kwanzaa%20celebration%20with%20kids%20participating%20in%20African%20drumming%20circle%2C%20colorful%20traditional%20Kwanzaa%20decorations%2C%20children%20doing%20art%20workshop%20with%20cultural%20crafts%2C%20educational%20family%20event%2C%20vibrant%20cultural%20heritage%20celebration&width=800&height=500&seq=kwanzaa-celebration-detail&orientation=landscape",
    overview: "Celebrating Kwanzaa at Children's Museum Houston offers families an enriching opportunity to learn about and participate in this important African American cultural celebration. The event features hands-on art workshops where children create traditional Kwanzaa crafts, an interactive African drumming circle that introduces kids to rhythmic traditions, and educational activities that teach the seven principles of Kwanzaa (Nguzo Saba) in age-appropriate, engaging ways. This special post-Christmas event provides a meaningful cultural experience that celebrates African heritage, community values, and the importance of family - making it both educational and fun for children of all backgrounds.",
    whatToExpect: [
      {
        title: "Interactive Art Workshops",
        description: "Children participate in hands-on art activities creating traditional Kwanzaa crafts, learning about the symbolism of the kinara (candleholder), mkeka (mat), and other cultural elements through creative expression."
      },
      {
        title: "African Drumming Circle",
        description: "Kids join an interactive drumming circle led by experienced instructors, learning basic rhythms and experiencing the joy of traditional African music and community participation."
      },
      {
        title: "Cultural Education",
        description: "Age-appropriate activities and storytelling teach children about Kwanzaa's seven principles (Unity, Self-Determination, Collective Work, Cooperative Economics, Purpose, Creativity, and Faith) in engaging, memorable ways."
      },
      {
        title: "Family Celebration",
        description: "The event creates a welcoming environment where families of all backgrounds can learn together, celebrate diversity, and appreciate African American cultural heritage."
      }
    ],
    practicalInfo: [
      {
        icon: "ri-time-line",
        title: "Event Date",
        detail: "December 26, 2025 (specific times TBA)"
      },
      {
        icon: "ri-ticket-line",
        title: "Admission",
        detail: "Museum admission required; check for special event pricing"
      },
      {
        icon: "ri-group-line",
        title: "Age Suitability",
        detail: "Designed for children and families"
      },
      {
        icon: "ri-parking-line",
        title: "Parking",
        detail: "Museum parking lot available"
      }
    ],
    helpfulTips: [
      "This is a great post-Christmas outing for kids - a meaningful cultural experience after the holiday rush",
      "Check museum admission and special event ticket information ahead of time as pricing may vary for special events",
      "Encourage children to participate actively in the drumming and art workshops - comfortable clothes recommended",
      "The museum can be busy during holiday break - arrive early for parking and to fully enjoy all activities",
      "Consider making it a full museum day - explore other exhibits before or after the Kwanzaa celebration",
      "This event is educational and fun for children of all backgrounds - a wonderful opportunity to learn about cultural diversity",
      "Bring a camera to capture your children's artwork and drumming participation",
      "The Children's Museum is designed for kids ages 0-12, with activities appropriate for various age groups",
      "Check the museum website or call ahead for specific event timing and any special instructions"
    ],
    historicalContext: "Children's Museum Houston, founded in 1980, has been a leader in hands-on, interactive learning experiences for children. The museum's Kwanzaa celebration reflects its commitment to cultural education and diversity, introducing children to important cultural traditions in engaging, age-appropriate ways. Kwanzaa, created in 1966 by Dr. Maulana Karenga, is a week-long celebration honoring African American culture, family, and community. The Children's Museum's event helps ensure that Houston's children grow up with appreciation for diverse cultural traditions and the values they represent."
  }
};

export default function HolidayDetail() {
  const { id } = useParams();
  const eventId = parseInt(id || '1');
  
  const event = holidayEventsData[eventId as keyof typeof holidayEventsData] || holidayEventsData[1];

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Event",
    "name": `${event.title} - ${event.venue}`,
    "description": event.description,
    "url": `${import.meta.env.VITE_SITE_URL}/holiday-detail/${id}`,
    "startDate": event.dates.split('–')[0].trim(),
    "endDate": event.dates.split('–')[1]?.trim() || event.dates,
    "location": {
      "@type": "Place",
      "name": event.location,
      "address": {
        "@type": "PostalAddress",
        "streetAddress": event.address.split(',')[0],
        "addressLocality": "Houston",
        "addressRegion": "Texas",
        "addressCountry": "US"
      }
    },
    "organizer": {
      "@type": "Organization",
      "name": event.venue
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <SEO
        title={`${event.title} - ${event.venue} - Eric Javidi`}
        description={`${event.description} ${event.dates}. ${event.location}.`}
        keywords={`${event.title}, ${event.venue}, Houston holiday events, Houston Christmas, Houston theatre, Houston ballet, Houston symphony`}
        ogTitle={`${event.title} - ${event.venue} - Eric Javidi`}
        ogDescription={event.description}
        ogUrl={`${import.meta.env.VITE_SITE_URL}/holiday-detail/${id}`}
        twitterTitle={`${event.title} - ${event.venue} - Eric Javidi`}
        twitterDescription={event.description}
        jsonLd={jsonLd}
      />

      {/* Navigation */}
      <nav className="bg-white shadow-sm border-b border-blue-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <Link to="/" className="text-xl font-semibold text-neutral-800">
                Eric Javidi
              </Link>
            </div>
            <div className="hidden md:block">
              <div className="ml-10 flex items-baseline space-x-8">
                <Link to="/" className="text-neutral-600 hover:text-blue-600 px-3 py-2 text-sm font-medium">
                  Home
                </Link>
                <Link to="/about" className="text-neutral-600 hover:text-blue-600 px-3 py-2 text-sm font-medium">
                  About
                </Link>
                <Link to="/guides" className="text-neutral-600 hover:text-blue-600 px-3 py-2 text-sm font-medium">
                  Guides
                </Link>
                <Link to="/holiday-season" className="text-neutral-600 hover:text-blue-600 px-3 py-2 text-sm font-medium">
                  Holiday Season
                </Link>
                <Link to="/fall-festivals" className="text-neutral-600 hover:text-blue-600 px-3 py-2 text-sm font-medium">
                  Fall Festivals
                </Link>
                <Link to="/resources" className="text-neutral-600 hover:text-blue-600 px-3 py-2 text-sm font-medium">
                  Resources
                </Link>
                <Link to="/contact" className="text-neutral-600 hover:text-blue-600 px-3 py-2 text-sm font-medium">
                  Contact
                </Link>
              </div>
            </div>
            <div className="md:hidden">
              <button className="text-neutral-600 hover:text-neutral-800">
                <i className="ri-menu-line text-xl"></i>
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Breadcrumb */}
      <div className="bg-blue-50 border-b border-blue-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <nav className="flex items-center space-x-2 text-sm">
            <Link to="/holiday-season" className="text-blue-600 hover:text-blue-800">Holiday Season</Link>
            <i className="ri-arrow-right-s-line text-neutral-400"></i>
            <span className="text-neutral-600">{event.title}</span>
          </nav>
        </div>
      </div>

      {/* Hero Section */}
      <section className="py-12 bg-gradient-to-br from-blue-50 to-purple-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="mb-4">
                <span className={`px-3 py-1 text-sm font-medium rounded-full ${
                  event.category === "Classic" ? "bg-red-100 text-red-800" :
                  event.category === "Musical" ? "bg-green-100 text-green-800" :
                  event.category === "Concert" ? "bg-blue-100 text-blue-800" :
                  event.category === "Ballet" ? "bg-purple-100 text-purple-800" :
                  "bg-orange-100 text-orange-800"
                }`}>
                  {event.category}
                </span>
              </div>
              <h1 className="text-3xl lg:text-4xl font-bold text-neutral-800 mb-2">
                {event.title}
              </h1>
              <p className="text-xl text-blue-600 mb-4">{event.venue}</p>
              <p className="text-lg text-neutral-600 mb-8">
                {event.description}
              </p>
              
              {/* Quick Info */}
              <div className="bg-white p-6 rounded-lg shadow-sm border border-blue-100">
                <h3 className="text-lg font-semibold text-neutral-800 mb-4">Event Details</h3>
                <div className="space-y-3">
                  <div className="flex items-start">
                    <i className="ri-calendar-line text-blue-600 mr-3 mt-1"></i>
                    <div>
                      <p className="text-sm font-medium text-neutral-800">Dates</p>
                      <p className="text-sm text-neutral-600">{event.dates}</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-map-pin-line text-blue-600 mr-3 mt-1"></i>
                    <div>
                      <p className="text-sm font-medium text-neutral-800">Location</p>
                      <p className="text-sm text-neutral-600">{event.location}</p>
                      <p className="text-xs text-neutral-500">{event.address}</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-ticket-line text-blue-600 mr-3 mt-1"></i>
                    <div>
                      <p className="text-sm font-medium text-neutral-800">Pricing</p>
                      <p className="text-sm text-neutral-600">{event.pricing}</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-group-line text-blue-600 mr-3 mt-1"></i>
                    <div>
                      <p className="text-sm font-medium text-neutral-800">Age Groups</p>
                      <p className="text-sm text-neutral-600">{event.ageGroups}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div>
              <div className="w-full h-96 bg-cover bg-center rounded-lg shadow-lg" style={{
                backgroundImage: `url('${event.image}')`
              }}></div>
            </div>
          </div>
        </div>
      </section>

      {/* Overview */}
      <section className="py-12 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-2xl font-bold text-neutral-800 mb-6">Overview</h2>
          <p className="text-neutral-700 leading-relaxed text-lg">
            {event.overview}
          </p>
        </div>
      </section>

      {/* What to Expect */}
      <section className="py-12 bg-blue-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-2xl font-bold text-neutral-800 mb-8">What to Expect</h2>
          <div className="grid md:grid-cols-2 gap-6">
            {event.whatToExpect.map((item, index) => (
              <div key={index} className="bg-white p-6 rounded-lg shadow-sm">
                <h3 className="text-lg font-semibold text-neutral-800 mb-3">
                  {item.title}
                </h3>
                <p className="text-neutral-600 text-sm">
                  {item.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Practical Information */}
      <section className="py-12 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-2xl font-bold text-neutral-800 mb-8">Practical Information</h2>
          <div className="grid md:grid-cols-2 gap-6">
            {event.practicalInfo.map((item, index) => (
              <div key={index} className="flex items-start">
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                  <i className={`${item.icon} text-blue-600`}></i>
                </div>
                <div>
                  <h3 className="font-semibold text-neutral-800 mb-1">{item.title}</h3>
                  <p className="text-sm text-neutral-600">{item.detail}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Helpful Tips */}
      <section className="py-12 bg-purple-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-2xl font-bold text-neutral-800 mb-6">Helpful Tips</h2>
          <div className="bg-white p-8 rounded-lg shadow-sm">
            <ul className="space-y-4">
              {event.helpfulTips.map((tip, index) => (
                <li key={index} className="flex items-start">
                  <i className="ri-lightbulb-line text-purple-600 mr-3 mt-1 flex-shrink-0"></i>
                  <span className="text-neutral-700">{tip}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      {/* Historical Context */}
      <section className="py-12 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-2xl font-bold text-neutral-800 mb-6">Historical Context</h2>
          <div className="bg-blue-50 p-8 rounded-lg border-l-4 border-blue-600">
            <p className="text-neutral-700 leading-relaxed">
              {event.historicalContext}
            </p>
          </div>
        </div>
      </section>

      {/* Map */}
      <section className="py-12 bg-neutral-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-2xl font-bold text-neutral-800 mb-6">Location</h2>
          <div className="bg-white rounded-lg overflow-hidden shadow-sm">
            <iframe
              src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8&q=${encodeURIComponent(event.address)}`}
              width="100%"
              height="400"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title={`${event.title} Location`}
            ></iframe>
          </div>
        </div>
      </section>

      {/* More Holiday Events */}
      <section className="py-12 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-2xl font-bold text-neutral-800 mb-8">More Holiday Events</h2>
          <div className="grid md:grid-cols-3 gap-6">
            <Link to="/holiday-detail/1" className="bg-blue-50 rounded-lg overflow-hidden hover:shadow-md transition-shadow cursor-pointer">
              <div className="h-32 bg-cover bg-center" style={{
                backgroundImage: `url('https://readdy.ai/api/search-image?query=A%20Christmas%20Carol%20theatrical%20production%20with%20Victorian%20costumes%20and%20dramatic%20lighting&width=300&height=200&seq=christmas-carol-thumb&orientation=landscape')`
              }}></div>
              <div className="p-4">
                <h3 className="font-semibold text-neutral-800 mb-1">A Christmas Carol</h3>
                <p className="text-sm text-neutral-600">Alley Theatre • Nov 16 - Dec 28</p>
              </div>
            </Link>
            
            <Link to="/holiday-detail/4" className="bg-blue-50 rounded-lg overflow-hidden hover:shadow-md transition-shadow cursor-pointer">
              <div className="h-32 bg-cover bg-center" style={{
                backgroundImage: `url('https://readdy.ai/api/search-image?query=The%20Nutcracker%20ballet%20performance%20with%20dancers%20in%20elegant%20costumes&width=300&height=200&seq=nutcracker-thumb&orientation=landscape')`
              }}></div>
              <div className="p-4">
                <h3 className="font-semibold text-neutral-800 mb-1">The Nutcracker</h3>
                <p className="text-sm text-neutral-600">Houston Ballet • Nov 28 - Dec 28</p>
              </div>
            </Link>
            
            <Link to="/holiday-season" className="bg-blue-100 rounded-lg p-6 flex items-center justify-center text-center hover:bg-blue-200 transition-colors cursor-pointer">
              <div>
                <div className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-3">
                  <i className="ri-arrow-right-line text-white"></i>
                </div>
                <h3 className="font-semibold text-blue-800 mb-1">View All Events</h3>
                <p className="text-sm text-blue-600">Discover more holiday magic</p>
              </div>
            </Link>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-neutral-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8">
            <div className="md:col-span-2">
              <h3 className="text-xl font-semibold mb-4">Eric Javidi</h3>
              <p className="text-neutral-300 mb-4">
                Houston-based storyteller exploring where the city's history meets its natural landscapes.
              </p>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Quick Links</h4>
              <ul className="space-y-2">
                <li><Link to="/guides" className="text-neutral-300 hover:text-white">Guides</Link></li>
                <li><Link to="/holiday-season" className="text-neutral-300 hover:text-white">Holiday Season</Link></li>
                <li><Link to="/fall-festivals" className="text-neutral-300 hover:text-white">Fall Festivals</Link></li>
                <li><Link to="/resources" className="text-neutral-300 hover:text-white">Resources</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Connect</h4>
              <ul className="space-y-2">
                <li><a href="https://readdy.ai/?origin=logo" className="text-neutral-300 hover:text-white">Made with Readdy</a></li>
              </ul>
            </div>
          </div>
          <div className="border-t border-neutral-700 mt-8 pt-8 text-center">
            <p className="text-neutral-400">© 2024 Eric Javidi. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
